import { render, staticRenderFns } from "./SaveEmailModal.vue?vue&type=template&id=6a553fe5&scoped=true&lang=pug"
import script from "./SaveEmailModal.vue?vue&type=script&lang=js"
export * from "./SaveEmailModal.vue?vue&type=script&lang=js"
import style0 from "./SaveEmailModal.vue?vue&type=style&index=0&id=6a553fe5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a553fe5",
  null
  
)

export default component.exports